<template>
  <div
    class="option-card"
    v-hover-intent="{
      onEnter: () => $emit('preview', option),
      onExit: () => $emit('preview', null)
    }"
    @click="$emit('click', option)"
  >
    <template v-if="!$slots.default">
      <div class="option-card-img">
        <aha-icon
          :name="option.icon"
          maintainColor
        />
      </div>
      <div class="option-card-title font-bold text-base">
        {{ option.name }}
      </div>
    </template>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'FeatureOptionCard',
  props: {
    option: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.option-card {
  @apply flex justify-center items-center flex-col;
  @apply p-5;
  @apply text-center cursor-pointer bg-white-100;
  @apply border border-solid border-secondary-20 rounded-xl hover:border-primary-90;
}

.option-card-img {
  @apply flex justify-center items-center;
  @apply w-11 h-11;
}
</style>
